import { Settings, WinLinesType } from "../../Settings";
import { WinLinesAnimationParams, GenericWinLinesAnimation, GenericWinLinesAnimationPIXIAPP } from "./GenericWinLinesAnimation";
import { IWinLinesFactoryPIXIAPP } from "./IWinLinesFactoryPIXIAPP";
import { WinLinesAnimation } from "./WinLinesAnimation";
import { WinNumberLinesAnimation } from "./WinNumberLinesAnimation";
import { WinSquares1MarkerAnimation } from "./WinSquares1MarkerAnimation";
import { WinSquareAnimations } from "./WinSquaresAnimations";
import { WinSquaresAnimationsSpinePIXIAPP } from "./WinSquaresAnimationsSpinePIXIAPP";
import { WinSquareMarkesAnimations } from "./WinSquaresMarkersAnimations";

export class WinLineTypeFactoryPIXIAPP implements IWinLinesFactoryPIXIAPP
{
   public CreateWinLinesPIXIAPP(params: WinLinesAnimationParams):GenericWinLinesAnimationPIXIAPP
    {        
        if (Settings.winLinesType == WinLinesType.WinSquareAnimations) {
            return new WinSquaresAnimationsSpinePIXIAPP(params);
        }else {
            throw `its not implemented pixi app for ${Settings.winLinesType}`;
        }       
        return null
    }
}